import { TileDeleteButton } from "@/components/ui-v2/Tiles/common/TileDeleteButton";
import {
  VideoPreviewTile,
  VideoPreviewTileProps,
} from "@/components/ui-v2/Tiles/VideoPreviewTile/VideoPreviewTile";

interface FileSelectPreviewListVideoTileProps extends VideoPreviewTileProps {
  onAction: (event: React.MouseEvent, action: string) => void;
}

export const FileSelectPreviewListVideoTile = (
  props: FileSelectPreviewListVideoTileProps,
) => {
  const { onAction, ...rest } = props;

  return (
    <VideoPreviewTile
      {...rest}
      onAction={onAction}
      slots={{
        bottomLeftEl: TileDeleteButton,
      }}
      slotProps={{
        bottomLeftEl: {
          onAction,
          sx: {
            m: 1,
          },
        },
      }}
    />
  );
};
